import React, { useState } from "react";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import OrderModal from "../../../components/OrderModal";
import Mail from "@mui/icons-material/Mail";
import Message from "@mui/icons-material/Message";
import Link from "@mui/icons-material/Link";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { showSuccessSnackbar } from "../../../actprep-ui/utils/feedback";
import layout from "../../../actprep-ui/constants/layout";
import { apiOrigin } from "../../../actprep-ui/constants/api";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";
import { dataGridNestedColumnGetter } from "../../../actprep-ui/utils/tables";

const parentOnboardingLink = (parentUUID) => {
  navigator.clipboard.writeText(
    `
        ${apiOrigin}/parent/signup/${parentUUID}/
    `.trim()
  );

  showSuccessSnackbar("Parent Onboarding Link Copied!");
};

const ordersColumns = [
  {
    field: "parent",
    headerName: "Parent",
    width: 150,
    valueGetter: (parent) =>
      parent ? `${parent.first_name} ${parent.last_name}` : "",
  },
  {
    field: "parent.email",
    headerName: "Parent Email",
    width: 200,
    valueGetter: dataGridNestedColumnGetter,
  },
  {
    field: "total_paid",
    headerName: "Total Paid",
    type: "number",
    width: 100,
  },
  {
    field: "created_at",
    headerName: "Created At",
    type: "date",
    width: 100,
    valueGetter: (value) => new Date(value),
  },
  {
    field: "tickets",
    headerName: "Cohort",
    width: 130,
    valueGetter: (value) =>
      value[0]?.cohort.event_name.replace("Start Date", "").trim(),
  },
  {
    field: "parent_emailed",
    headerName: "Parent Emailed",
    type: "boolean",
    width: 150,
  },
  {
    field: "parent_account_created",
    headerName: "Parent Account Created",
    type: "boolean",
    width: 150,
  },
  {
    field: "tickets_assigned",
    headerName: "Ticket(s) Assigned",
    type: "boolean",
    width: 150,
  },
  {
    field: "student_names",
    headerName: "Students",
    width: 300,
  },
  {
    field: "actions",
    type: "actions",
    width: 120,
    getActions: ({ row }) => {
      return [
        <Tooltip title="Retry Order Email" key={1}>
          <GridActionsCellItem
            icon={<Mail color="primary" />}
            label="Retry Order Email"
          />
        </Tooltip>,
        <Tooltip title="Retry Order Text" key={2}>
          <GridActionsCellItem
            icon={<Message color="primary" />}
            label="Retry Order Text"
          />
        </Tooltip>,
        <Tooltip title="Copy Parent Onboarding Link" key={3}>
          <GridActionsCellItem
            icon={<Link color="primary" />}
            label="Copy Parent Onboarding Link"
            onClick={() => parentOnboardingLink(row.parent.uuid)}
          />
        </Tooltip>,
      ];
    },
  },
];
export default function Orders() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowSelect = (params) => {
    setSelectedRow(params.row);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };
  return (
    <Grid
      size={12}
      sx={{
        marginTop: `${layout.navBarHeight + 1}rem`,
      }}
    >
      <ContentBox
        style={{
          maxHeight: "80vh",
          height: "500rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h5" fontWeight={"bold"}>
          Orders
        </Typography>
        <Box
          sx={{
            height: "90%",
          }}
        >
          <PaginatedTable
            searchable
            tableName={"Orders"}
            apiUrl={apiUrls.admin.orders()}
            columns={ordersColumns}
            urlParams={{
              keep_related: "true",
              exclude: ["payload", "tickets__payload"],
            }}
            initialState={{
              pinnedColumns: {
                right: ["actions"],
              },
            }}
            onRowClick={handleRowSelect}
            sortingMode={sortingModes.SERVER}
            disableCellFocus
          />
        </Box>
        <OrderModal
          open={modalOpen}
          handleClose={handleClose}
          order={selectedRow}
        />
      </ContentBox>
    </Grid>
  );
}
